import APPOINTMENT_URL_PREFIX from "./constants/appointment-url-prefix";

export default function getAppointmentUrl({
  twilio_url_code,
}: AppointmentMetaData) {
  return `${window.location.origin}${APPOINTMENT_URL_PREFIX}${twilio_url_code}`;
}
